<p>
    @if (!showInfo) {
        <ap-button (onClick)="toggleAndScrollTo('#moreInfo')" data-bb="expand" [text]="true">
            {{ 'betaalverzoek-info.label.expand' | apContent }}
        </ap-button>
    }
    @if (showInfo) {
        <ap-button (onClick)="toggleShowInfo()" [text]="true" data-bb="collapse">
            {{ 'betaalverzoek-info.label.collapse' | apContent }}
        </ap-button>
    }
</p>
@if (showInfo) {
    <ap-panel type="primary">
        <div apPanelHeader id="moreInfo">
            <h2>
                {{ 'betaalverzoek-info.panel.header' | apContent }}
            </h2>
        </div>
        <div ap-panel-body>
            <ap-content style="overflow-wrap: break-word" key="betaalverzoek-info.panel.text"></ap-content>
        </div>
    </ap-panel>
}
@if (showInfo) {
    <div>
        <h2>{{ 'betaalverzoek-info.notpresent.header' | apContent }}</h2>
        {{ 'betaalverzoek-info.notpresent.text' | apContent }}
    </div>
}
